import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		fontSize: '2.6rem',
		textAlign: 'center',
		fontWeight: '600',
		color: theme.palette.primary.main,
		alignItems: 'center',
		justifyContent: 'center'
	},
	dividerStyles: {
		marginBottom: '1rem'
	},
	mainPagePaperMarginStyle: {
		paddingTop: '0.08rem',
		borderRadius: '1rem !important',
		margin: '0 3rem',
		paddingBottom: '6rem'
	},
	basicOutlinedBox: {
		border: '1px solid darkgrey',
		margin: '2rem',
		padding: '2rem',
		width: '100%',
		borderRadius: '1rem'
	},
	icon: {
		cursor: 'pointer',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		}
	},
	modalContentStyle: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '30% !important',
		height: '30% ',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '1rem 2rem',
		textAlign: 'center',
		overflowY: 'scroll'
	},
	modalContentItem: {
		display: 'flex',
		justifyContent: 'center'
	},
	pageStyles: {
		padding: '1rem',
		margin: '2rem'
	},
	gridStyles: {
		margin: '1rem ',
		padding: '3rem'
	},
	sectionOverview: {
		height: 'fit-content',
		padding: '2rem',
		'& div': {
			borderRadius: '1rem'
		}
	},
	sectionOverviewPaper: {
		padding: '4rem',
		margin: '1rem',
		height: '100%',
		overflowY: 'scroll',
		textAlign: 'left'
	},
	minorMarginLeftAndRight: {
		margin: '0 1rem 0 1rem !important'
	},
	minorMarginTopAndBottom: {
		margin: '1rem 0 1rem 0 !important'
	},
	minorMarginAround: {
		margin: '1rem !important'
	},
	mediumMarginLeftAndRight: {
		margin: '0 2rem 0 2rem !important'
	},
	mediumMarginTopAndBottom: {
		margin: '2rem 0 2rem 0 !important'
	},
	mediumMarginAround: {
		margin: '2rem !important'
	},
	textOverflowStyles: {
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap'
	},
	configOverview: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '70% !important',
		height: '70% ',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '3rem',
		overflow: 'scroll',
		position: 'relative'
	}
}));
